export default "__VITE_ASSET__AUkUoFv1__"